const baseUrl = process.env.REACT_APP_API_BASE_URL;

export const getMeasurementPdf = async (measurementId, theme , locale) => {
    try {
      const params = new URLSearchParams();
      params.set('measurement_uuid', measurementId);
      params.set('theme', theme);
      params.set('locale', locale);
  
      const response = await fetch(`${baseUrl}/get-measurement-pdf?${params.toString()}`, { });
  
      if (!response.ok) {
        // Optional: handle 401 vs 404 vs 500, etc.
        throw new Error(`Failed to fetch PDF. Status: ${response.status}`);
      }
  
      // Convert response to Blob (PDF)
      const pdfBlob = await response.blob();
      return pdfBlob;
    } catch (error) {
      console.error("Error fetching PDF:", error);
      throw error;
    }
  };
  


export const fetchSessions = async (kc) => {
    try {
        const response = await fetch(`${baseUrl}/list-connected-headsets`, {
            headers: {
                Authorization: `Bearer ${kc.token}`,
            },
        });
        if (!response.ok) {
            throw new Error('Failed to fetch sessions');
        }
        return await response.json();
    } catch (error) {
        console.error("Error fetching sessions:", error);
        //throw error;
    }
};

export const deleteSession = async (kc, sessionId) => {
    try {
        const response = await fetch(`${baseUrl}/disconnect-headset/${sessionId}`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${kc.token}`,
            },
        });
        if (!response.ok) {
            throw new Error('Failed to delete session');
        }
        return true; // Indicate success
    } catch (error) {
        console.error("Error deleting session:", error);
        //throw error;
    }
};



export const listMeasurements = async ( kc, params ) => {
    try {
        const response = await fetch(`${baseUrl}/list-measurements?${params.toString()}`, {
            headers: {
                Authorization: `Bearer ${kc.token}`,
            },
        })
        return response.json()
    } catch (error) {
        console.error('Error list-measurements:', error);
    }
}

export const getLastMeasurementId = async ( kc ) => {

    const params = new URLSearchParams();
    params.append('page', 1);
    params.append('size', 1);

    try {
        const response = await fetch(`${baseUrl}/list-measurements?${params.toString()}`, {
            headers: {
                Authorization: `Bearer ${kc.token}`,
            },
        })

        return response.json()
    } catch (error) {
        console.error('Error list-measurements:', error);
    }
}


export const getSingleDataMeasurement = ( async ( kc, patientId) => {
    const resp = await fetch(`${baseUrl}/get-single-measurement?measurement_uuid=${patientId}`, {
        headers: {
            Authorization: `Bearer ${kc.token}`,
        },
    })
    const json = await resp.json();
    console.log('getSingleDataMeasurement', json)
    return await json;
});

export const getStatisticsChunked = async (kc, selectedTimeChunk) => {
    try {
        const response = await fetch(`${baseUrl}/statistics-chunked?timechunks=${selectedTimeChunk}`, {
            headers: {
                Authorization: `Bearer ${kc.token}`
            }
        });

        return await response.json()
    } catch (error) {
        console.error('Error fetching statistics:', error);
    }
};

export const getStatisticsTotal = async (kc, params) => {
    try {
        const response = await fetch(`${baseUrl}/statistics-total?${params.toString()}`, {
            headers: {
                accept: 'application/json',
                Authorization: `Bearer ${kc.token}`
            }
        });
        return await response.json()
    } catch (error) {
        console.error('Error fetching statistics:', error);
    }
};


export const privacyStatus = async (kc) => {
    try {
        const response = await fetch(`${baseUrl}/data-privacy-status`, {
            headers: {
                Authorization: `Bearer ${kc.token}`
            }
        });

        if (!response.ok) {
            throw new Error('Failed to fetch privacy status');
        }

        const data = await response.json(); // First, correctly await the JSON response
        return data.approved; // Then access the 'approved' property
    } catch (error) {
        console.error('Error privacyStatus:', error);
        return false; // Return false directly here since we're only interested in the boolean
    }
}


export const approveDataPrivacy = async (kc, value) => {
    try {
        const response = await fetch(`${baseUrl}/approve-data-privacy`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${kc.token}`,
            },
            body: JSON.stringify({
                approved: value,
            })
        });

        if (!response.ok) {
            throw new Error('Failed to update privacy approval status');
        }

        return await response.json(); // Expecting a JSON object with a success message
    } catch (error) {
        console.error('Error approveDataPrivacy:', error);
        return { message: 'Failed to update privacy approval status' }; // Provide a default error message
    }
}


export const getUserDetails = async (kc) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/user-details`, {
            headers: {
                Authorization: `Bearer ${kc.token}`
            }
        });
        if (response.ok) {
            return  await response.json();
        }
    } catch (error) {
        console.error('Error loading user details:', error);
    }
}


export const saveUserDetails = async (kc, params, toast, t) => {
    //console.log('saveUserDetails', params)
    try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/user-details`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${kc.token}`
            },
            body: params
        });
        if (response.ok) {
            displayToast(toast, 'success', t('Succces'), t('Settings saved successfully!'))
            return  true
        }
    } catch (error) {
        displayToast(toast, 'error', t('Error'), t('Failed to save settings.'))
        return  false

    }
}

export const deleteLogoUser = async (kc, toast, t ) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/delete-logo`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${kc.token}`
            }
        });
        if (response.ok) {
            displayToast(toast, 'success', t('Succces'), t('Logo deleted successfully!'))
            return true
        } else {
            displayToast(toast, 'error', t('Error'), t('Failed to save settings.'))
            return false
            //throw new Error('Failed to delete logo');
        }
    } catch (error) {
        console.error('Error deleting logo:', error);
        alert('Error deleting logo.');
        return false
    }
}



export const updateReferenceName = async (kc, id, reference, toast, t) => {
    try {
        const response = await fetch(`${baseUrl}/update-reference-name`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${kc.token}`
            },
            body: JSON.stringify({
                measurement_uuid: id,
                ReferenceName: reference
            }),
        });
        if (response.ok) {
            const json = await response.json();
            displayToast(toast, 'success', t('Succces'), t('SucessUpdateReferenceName'))
            return json;
        } else {
            displayToast(toast, 'error', t('Error'), t('Failed update reference name'))
            throw new Error('Failed update reference name');
        }
    }catch (error) {
        console.error('Error:', error);
    }
};


export const markAsReadyForOrdering = async (kc, id, toast, t) => {
    try {
        const response = await fetch(`${baseUrl}/mark-for-ordering`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${kc.token}`
            },
            body: JSON.stringify({
                measurement_uuid: id
            }),
        });
        if (response.ok) {
            const json = await response.json();
            displayToast(toast, 'success', t('Succces'), t('SucessfullyMarkedforOrdering'))
            return json;
        } else {
            displayToast(toast, 'error', t('Error'), t('FailedMeakedforOrdering'))
            throw new Error('Failed update Measurement Order Status');
        }
    }catch (error) {
        console.error('Error:', error);
    }
};



export const updateCorridorLength = async (kc, mimetikaId, vertexDistance, pantoscopicAngle, toast, t) => {
    try {
        const response = await fetch(`${baseUrl}/update-corridorlength`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${kc.token}`
            },
            body: JSON.stringify({
                AdditionalCorrection: 2,
                BVD: vertexDistance,
                PantoAngle: pantoscopicAngle,
                measurement_uuid: mimetikaId,
                PersistanceFlag: 0
            }),
        });
        if (response.ok) {
            const json = await response.json();
            //displayToast(toast, 'success', t('Succces'), t(json.message))
            return json;
        } else {
            displayToast(toast, 'error', t('Error'), t('Failed update measurement'))
            throw new Error('Failed update reference name');
        }
    }catch (error) {
        console.error('Error:', error);
    }
};

export const updateSelectedImages = async (kc, measurementId, selectedImages, toast, t) => {
    try {
        const response = await fetch(`${baseUrl}/update-selected-images`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${kc.token}`
            },
            body: JSON.stringify({
                measurementId: measurementId,
                selectedImages: selectedImages
            }),
        });
        if (response.ok) {
            const json = await response.json();
            //displayToast(toast, 'success', t('Success'), t(json.message))
            return json;
        } else {
            displayToast(toast, 'error', t('Error'), t('Failed to update selected images'))
            throw new Error('Failed to update selected images');
        }
    } catch (error) {
        console.error('Error:', error);
    }
};

export const getSelectedImages = async (kc, measurementId) => {
    try {
        const response = await fetch(`${baseUrl}/get-selected-images?measurementId=${measurementId}`, {
            headers: {
                Authorization: `Bearer ${kc.token}`
            },
        });
        if (response.ok) {
            return await response.json();
        } else {
            throw new Error('Failed to fetch selected images');
        }
    } catch (error) {
        console.error('Error:', error);
    }
};




const displayToast = (toast, severity, summary, message) => {
    toast.current.show({severity: severity, summary: summary, detail: message })
}
